import { useState, useEffect, useRef } from "react";

type TabType = "layers" | "styles" | "traits";

export function PageBuilderRightPanel() {
  const [activeTab, setActiveTab] = useState<TabType>("layers");
  const layersRef = useRef<HTMLDivElement | null>(null);
  const stylesRef = useRef<HTMLDivElement | null>(null);
  const traitsRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    // Los contenedores ya existen en el DOM (en los refs)
    if (layersRef.current) layersRef.current.style.display = activeTab === "layers" ? "block" : "none";
    if (stylesRef.current) stylesRef.current.style.display = activeTab === "styles" ? "block" : "none";
    if (traitsRef.current) traitsRef.current.style.display = activeTab === "traits" ? "block" : "none";
  }, [activeTab]);

  return (
    <aside style={rightPanelStyle}>
      <div style={tabsStyle}>
        <button style={{ ...tabButtonStyle, ...(activeTab === "layers" ? activeTabStyle : {}) }} onClick={() => setActiveTab("layers")}>
          Layers
        </button>
        <button style={{ ...tabButtonStyle, ...(activeTab === "styles" ? activeTabStyle : {}) }} onClick={() => setActiveTab("styles")}>
          Styles
        </button>
        <button style={{ ...tabButtonStyle, ...(activeTab === "traits" ? activeTabStyle : {}) }} onClick={() => setActiveTab("traits")}>
          Traits
        </button>
      </div>

      <div style={contentStyle}>
        <div ref={layersRef} className="gjs-layers-container" style={tabContentStyle} />
        <div ref={stylesRef} className="gjs-styles-container" style={tabContentStyle} />
        <div ref={traitsRef} className="gjs-traits-container" style={tabContentStyle} />
      </div>
    </aside>
  );
}

const rightPanelStyle: React.CSSProperties = {
  width: "320px",
  borderLeft: "1px solid var(--fx-surface-border, #E2E8F0)",
  background: "var(--fx-surface-base, #FFFFFF)",
  display: "flex",
  flexDirection: "column",
  overflowY: "hidden",
};

const tabsStyle: React.CSSProperties = {
  display: "flex",
  borderBottom: "1px solid var(--fx-surface-border, #E2E8F0)",
  backgroundColor: "var(--fx-surface-sunken, #F8FAFC)",
};

const tabButtonStyle: React.CSSProperties = {
  flex: 1,
  padding: "12px",
  border: "none",
  background: "transparent",
  cursor: "pointer",
  fontSize: "12px",
  fontWeight: 600,
  color: "var(--fx-surface-textsecondary, #64748B)",
  transition: "all 0.2s",
};

const activeTabStyle: React.CSSProperties = {
  background: "var(--fx-surface-base, #FFFFFF)",
  color: "#2563eb",
  borderBottom: "2px solid #2563eb",
};

const contentStyle: React.CSSProperties = {
  flex: 1,
  overflowY: "auto",
  padding: "0",
  color: "var(--fx-surface-text, #0F172A)",
};

const tabContentStyle: React.CSSProperties = {
  width: "100%",
  height: "100%",
  color: "var(--fx-surface-text, #0F172A)",
};
